module.exports = __webpack_public_path__ + "img/glitter_15.ad9a9ff6.jpg";